import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, FormButton, ImportButton, InputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import { CommonApiData } from '../CommonComponents/EnvConfig';

const ManufactureMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [formData, setFormData] = useState({
        manufactureMasterID: '',
        manufactureCode: 'System Generated',
        manufactureName: '',
        assetCode: '',
        isActive: true
    });

    const getManufactureMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowManufactureMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        } if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async() => {
        setFormData({
            manufactureMasterID: '',
            manufactureCode: 'System Generated',
            manufactureName: '',
            assetCode: '',
            isActive: true
        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateManufactureMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditManufactureMaster`, { manufactureMasterID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteManufactureMaster`, { manufactureMasterID: id }, getManufactureMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getManufactureMasterData(value);
    };

    const DownloadFormat = async () => {
        await DownloadFileAtURL('ManufactureMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'ManufactureMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            manufactureCode: 'System Generated',
        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("manufactureName", "assetCode", "isActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateManufactureMaster', ImportData, Data2, getManufactureMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }

    useEffect(() => {
        getManufactureMasterData()
        document.title = 'Manufacture Master'
        inputrefs.current['txtManufactureName'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Manufacture Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                            <div className='row'>
                                <InputBox
                                    id="txtManufactureCode"
                                    type="text"
                                    label='Manufacture Code'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtManufactureName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='System Generated'
                                    name='ManufactureCode'
                                    value={formData.manufactureCode}
                                    disabled
                                />
                                <InputBox
                                    id="txtManufactureName"
                                    type="text"
                                    label='Manufacture Name'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"

                                    required={true}
                                    placeholder="Manufacture Name"
                                    maxLength='50'
                                    value={formData.manufactureName}
                                    onChange={(e) => setFormData({ ...formData, manufactureName: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAssetCode'].focus()
                                        }
                                    }}
                                />
                                <AutoCompleteBoxNew
                                    id="txtAssetCode"
                                    placeholder="Asset"
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    label={'Asset'}
                                    required={true}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        }
                                    }}
                                    // contextKey={formData.productFamilyCode}
                                    autocompleteType='GetAssetMaster'
                                    value={formData.assetCode || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, assetCode: newInputValue })
                                        }
                                    }}
                                    maxLength='50'
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />
                            </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(`/api/Master/ShowManufactureMaster`, filterData, 'Manufacture Master')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                handleDelete={handleDelete}
                handleEdit={handleEditData}
                loading={isLoading}
                PageName={'ManufactureMaster'}
                handleFilter={() => {
                    getManufactureMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default ManufactureMaster;